module.exports = __webpack_public_path__ + "img/yy.a6801304.png";